import {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";

import {useWipLevelV2} from "~/api/hooks/useWipLevelV2";
import {useGame} from "~/contexts/game-manager/GameManagerProvider";
import useLevelLoader from "~/contexts/loader/useLevelLoader";

const useLoadCurrentWipLevel = () => {
  const {id} = useParams<{id: string}>();
  const navigate = useNavigate();

  const {gameManager} = useGame();

  // Load the working level data.
  const {data: level, isError} = useWipLevelV2({id});

  const load = useLevelLoader();

  // Redirect if an error occurs while loading the level.
  useEffect(() => {
    if (isError) {
      navigate("/create");
    }
  }, [isError, navigate]);

  // Initial load / level change.
  useEffect(() => {
    if (id && level) {
      load(id, level);
    }
  }, [id, level, load]);

  // Reload current level whenever a round starts.
  useEffect(() => {
    if (!gameManager || !id || !level) {
      return;
    }

    const handleRoundStarted = () => {
      load(id, level, true);
    };

    gameManager.on("round-started", handleRoundStarted);

    return () => {
      gameManager.off("round-started", handleRoundStarted);
    };
  }, [gameManager, id, level, load]);

  return null;
};

export default useLoadCurrentWipLevel;
